// removed by extract-text-webpack-plugin
module.exports = {"line":"c-ProductItem__line","item":"c-ProductItem__item","details":"c-ProductItem__details","attributes":"c-ProductItem__attributes","image":"c-ProductItem__image","left":"c-ProductItem__left","right":"c-ProductItem__right","buttons":"c-ProductItem__buttons","quantity":"c-ProductItem__quantity","value":"c-ProductItem__value","remove":"c-ProductItem__remove","removeButton":"c-ProductItem__removeButton","price":"c-ProductItem__price","giftWrap":"c-ProductItem__giftWrap","ageLimitLabel":"c-ProductItem__ageLimitLabel"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ProductItem/ProductItem.scss
// module id = 536
// module chunks = 0